module.exports = __webpack_public_path__ + "4e9dfe9d98125db147dcfc8ec5bb574c.svg";